/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { notificationContainer } from 'utils/notificationContainer';
import { PayloadAction } from '@reduxjs/toolkit';
import fileDownload from 'js-file-download';
import {
	TGetProductTypeRequest,
	TGetProductTypeResponsePayload,
	TSkuRequest,
	TSkuResponsePayload,
	TDownloadFileRequest,
	TDownloadFileResponsePayload,
} from './types';
import {
	getProductTypeRequest,
	getProductTypeSuccess,
	getProductTypeError,
	getSkuRequest,
	getSkuSuccess,
	getSkuError,
	downloadFileRequest,
	downloadFileSuccess,
	gpsrInitState,
} from './reducer';

function* getProductTypeRequestWorker(action: PayloadAction<TGetProductTypeRequest>) {
	try {
		const response: TGetProductTypeResponsePayload = yield call(
			api.gpsr.getProductType,
			action.payload,
		);
		yield put(getProductTypeSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(
			// 	error?.response?.data?.message ?? error.message ?? 'File download error',
			// 	'error',
			// );
			yield put(getProductTypeError(error?.response?.data?.message ?? error.message ?? ''));
		}
	}
}

function* getSkuRequestWorker(action: PayloadAction<TSkuRequest>) {
	try {
		const response: TSkuResponsePayload = yield call(api.gpsr.getSku, action.payload);
		yield put(getSkuSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(
				error?.response?.data?.message ?? error.message ?? 'File download error',
				'error',
			);
			yield put(getSkuError(error?.response?.data?.message ?? error.message ?? ''));
		}
	}
}

function* downloadFileRequestWorker(
	action: PayloadAction<TDownloadFileRequest>,
): Generator<any, void, any> {
	try {
		const response: TDownloadFileResponsePayload = yield call(
			api.gpsr.downloadFile,
			action.payload,
		);
		if (response) {
			yield fileDownload(response, 'gpsr_declaration_of_conformity.pdf');
		}
		yield put(downloadFileSuccess());
		notificationContainer('Document downloaded successfully', 'success');
	} catch (error) {
		if (axios.isAxiosError(error)) {
			const responseData = yield error?.response?.data.text().then((data: any) => data);
			notificationContainer(JSON.parse(responseData)?.message ?? 'File download error', 'error');
		}
		yield put(downloadFileSuccess());
	}
}

export function* gpsrSaga() {
	yield takeEvery(getProductTypeRequest.type, getProductTypeRequestWorker);
	yield takeEvery(getSkuRequest.type, getSkuRequestWorker);
	yield takeEvery(downloadFileRequest.type, downloadFileRequestWorker);
}
